import { html } from '../../../lib/html'

const icon = html`<svg
  width="13"
  height="18"
  viewBox="0 0 13 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect y="9" width="3" height="9" fill="currentColor" />
  <rect x="5" width="3" height="18" fill="currentColor" />
  <rect x="10" y="9" width="3" height="9" fill="currentColor" />
</svg>`

export default icon
